import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { updateConfig } from "../../../../../store/slices/Admin/Store/storeSlice";
import dayjs from "dayjs";

const useStoreHours = (formik) => {
  const dispatch = useDispatch();
  const { isEdit, pickupTimeError } = useSelector((state) => state.store);

  const handleNext = () => {
    dispatch(
      updateConfig((state) => {
        state.activeTab = "Dine-in Hours";
      })
    );
  };

  const handleCloseModal = () => {
    dispatch(
      updateConfig((state) => {
        state.showCreateModal = !state.showCreateModal;
        state.isEdit = false;
      })
    );
  };

  const daysOfWeek = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];

  const getTimeValue = (day, type) => {
    const value = formik?.values?.pickup_hours?.[day]?.[type];
    return value ? dayjs(value, "h:mm A") : null;
  };

  const getStatus = (day) => {
    const dayData = formik?.values?.pickup_hours?.[day];
    if (dayData) {
      return dayData.status || 1;
    }
    return 2;
  };

  const handleTimeChange = (day, type, newValue) => {
    const existingDay = formik?.values?.pickup_hours?.[day] || {};
    const updatedPickupHours = {
      ...formik?.values.pickup_hours,
      [day]: {
        ...existingDay,
        [type]: newValue ? newValue.format("h:mm A") : null,
      },
    };
    formik.setFieldValue("pickup_hours", updatedPickupHours);
  };

  const handleToggle = (day, checked) => {
    const newStatus = checked ? 1 : 2;
    const existingDay = formik?.values?.pickup_hours?.[day] || {};
    const updatedPickupHours = {
      ...formik?.values.pickup_hours,
      [day]: {
        ...existingDay,
        status: newStatus,
      },
    };
    formik.setFieldValue("pickup_hours", updatedPickupHours);
  };

  const getMinToTime = (day) => {
    const fromTime = getTimeValue(day, "from");
    if (fromTime) {
      return fromTime.add(1, "hour");
    }
    return null;
  };

  return {
    isEdit,
    handleNext,
    handleCloseModal,
    daysOfWeek,
    handleTimeChange,
    handleToggle,
    getTimeValue,
    getStatus,
    getMinToTime,
    pickupTimeError,
  };
};

export default useStoreHours;
